import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const StarRatingSelector = ({ value, onChange, error }) => {
  const [hoverValue, setHoverValue] = useState(0);

  const handleStarClick = (rating) => {
    onChange(rating);
  };

  const handleStarHover = (rating) => {
    setHoverValue(rating);
  };

  const handleMouseLeave = () => {
    setHoverValue(0);
  };

  const getRatingLabel = (rating) => {
    const labels = {
      1: '시작 단계',
      2: '노력 중',
      3: '좋음',
      4: '훌륭함',
      5: '완벽함',
    };
    return labels?.[rating] || '';
  };

  const displayValue = hoverValue || value;

  return (
    <div className="w-full">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-3">
        <label className="text-sm md:text-base font-medium text-foreground">
          달성도 평가 <span className="text-error">*</span>
        </label>
        {displayValue > 0 && (
          <span className="text-sm md:text-base font-medium text-primary caption">
            {getRatingLabel(displayValue)}
          </span>
        )}
      </div>
      <div
        className="flex items-center justify-center sm:justify-start space-x-2 md:space-x-3 py-4"
        onMouseLeave={handleMouseLeave}
      >
        {[1, 2, 3, 4, 5]?.map((rating) => {
          const isActive = rating <= displayValue;
          return (
            <button
              key={rating}
              type="button"
              onClick={() => handleStarClick(rating)}
              onMouseEnter={() => handleStarHover(rating)}
              className="transition-gaming active:translate-y-px focus:outline-none"
              aria-label={`${rating}점 선택`}
            >
              <Icon
                name="Star"
                size={40}
                color="currentColor"
                className={`${isActive ? 'fill-current text-primary' : 'text-muted-foreground'} w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12`}
              />
            </button>
          );
        })}
      </div>
      {error && (
        <div className="flex items-center space-x-2 mt-2 text-error">
          <Icon name="AlertCircle" size={16} />
          <span className="text-sm caption">{error}</span>
        </div>
      )}
      <p className="text-xs md:text-sm text-muted-foreground mt-2 caption">
        1점(시작) ~ 5점(완벽) 사이에서 선택하세요
      </p>
    </div>
  );
};

export default StarRatingSelector;